import { z } from "zod";
import { BaseEvent } from "./base";
export const Test_Action = BaseEvent.extend({
    name: z.literal("events.superwall.com.ops.v1.Test_Action"),
    event: z.object({
        message: z.string().optional()
    })
});
